// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';


const firebaseConfig = {
  apiKey: "AIzaSyDSR1-X-5I3d-5IlRgeo7OMGsV1_Bdggnw",
  authDomain: "ig-reels-2-f9be0.firebaseapp.com",
  projectId: "ig-reels-2-f9be0",
  storageBucket: "ig-reels-2-f9be0.appspot.com",
  messagingSenderId: "964964205501",
  appId: "1:964964205501:web:83bf2a5fcb757b7729c8d4",
  measurementId: "G-KXXQ71DCXP"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
export default db;
export {auth};

//   db exporting here is giving access to the whole firebase database and we can use it in another file  